<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <!-- <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column> -->
    <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
    <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
    <el-table-column prop="payMoney" label="金额" align="center"></el-table-column>
    <el-table-column prop="batchOrderCount" label="充值卡数" align="center"></el-table-column>
    <el-table-column prop="orderStatus" label="状态" align="center"></el-table-column>
    <el-table-column prop="payType" label="支付方式" align="center"></el-table-column>
    <el-table-column prop="paymentTime" label="支付时间" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { wxUserOrderInfo } from "@/api/api.js";
export default {
  props: {
    userId: {
      type: [String]
    }
  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  methods: {
    Packagestatus(status) {
      let obj = {
        1: "未使用",
        2: "使用中",
        3: "已使用",
        4: "已过期",
        5: "已转移",
        6: "已作废",
      };
      return obj[status];
    },
    // 支付方式
    transferPayType(status){
      let obj = {
        1: "H5支付",
        2: "微信支付",
        3: "余额支付",
        4: "系统支付",
        5: "支付宝支付",
      };
      return obj[status];
    },
    transferOrderStatus(status) {
      let obj = {
        1: "未支付",
        2: "已支付",
        3: "已到账",
        4: "已退款"
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        userId:this.userId
      };
      wxUserOrderInfo(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            item.orderStatus = this.transferOrderStatus(item.orderStatus);
            item.payType = this.transferPayType(item.payType);
          })
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
  },
  created() {
  //  this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


